var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.$store.getters.systemLoad)?_c('NavBar'):_vm._e(),_c('OverLay'),_c('Loading'),_vm._l((_vm.$store.getters['show']),function(v,i){return _c('modal-template',{key:i,attrs:{"pageTemplate":v.from,"visible":v.show}})}),_c('router-view',{key:_vm.keyApp()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }